export const SEARCH_DEBOUNCE_TIME = 600
export const SCROLL_DEBOUNCE_TIME = 600
export const GET_PROJECTS_DEBOUNCE_TIME = 600
export const GET_PROJECTS_LIMIT = 12
export const GET_BIDS_LIMIT = 30
export const GET_REPORTS_LIMIT = 8
